import { useEffect, useState } from "react";

import {
  Card,
  CardContent,
  Button,
  Container,
  Grid,
  Typography,
  Box,
  Chip,
} from "@mui/material";

import { useNavigate } from "react-router-dom";

import { api } from "../api";
import MetricCard from "../components/MetricCard";

function ObligationsPage() {
  const navigate = useNavigate();

  const [obligations, setObligations] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const response = await api.get("/obligations");

    setObligations(response.data);
  };

  return (
    <Container
      maxWidth={false}
      sx={{
        maxWidth: "1700px",
        mx: "auto",
        px: { xs: 2, md: 5 },
        py: 5,
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          mb: 6,
        }}
      >
        <Typography
          variant="h3"
          fontWeight={700}
          sx={{
            mb: 1,
          }}
        >
          Obligations Dashboard
        </Typography>

        <Typography variant="h6" color="text.secondary">
          Upload, validate and monitor compliance evidence using AI
        </Typography>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(360px, 1fr))",
          gap: 4,
          alignItems: "stretch",
        }}
      >
        {obligations.map((item) => (
          <Card
            key={item.id}
            sx={{
              height: 290,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              borderRadius: 4,
              overflow: "hidden",
              background: "#fff",
              border: "1px solid #E5E7EB",
              boxShadow: "0 8px 24px rgba(0,0,0,.08)",
              transition: "all .25s ease",

              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 18px 40px rgba(0,0,0,.12)",
              },
            }}
          >
            <CardContent
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                p: 3,
              }}
            >
              <Chip
                label="OPEN"
                size="small"
                sx={{
                  alignSelf: "flex-start",
                  bgcolor: "#DCFCE7",
                  color: "#15803D",
                  fontWeight: 700,
                  mb: 2,
                }}
              />

              <Typography
                variant="h6"
                fontWeight={700}
                sx={{
                  lineHeight: 1.35,

                  height: 58, // exactly 2 lines
                  overflow: "hidden",

                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {item.title}
              </Typography>

              <Box sx={{ mt: 2 }}>
                <Typography variant="body2">
                  <strong>Department:</strong> {item.department}
                </Typography>

                <Typography variant="body2" sx={{ mt: 0.5 }}>
                  <strong>Due Date:</strong>{" "}
                  {new Date(item.due_date).toLocaleDateString()}
                </Typography>
              </Box>

              <Box sx={{ flexGrow: 1 }} />

              <Button
                fullWidth
                variant="contained"
                onClick={() => navigate(`/obligation/${item.id}`)}
                sx={{
                  mt: 3,
                  height: 48,
                  borderRadius: "14px",
                  textTransform: "none",
                  fontWeight: 700,
                  fontSize: 15,

                  background: "linear-gradient(135deg,#2563EB,#1D4ED8)",

                  color: "#fff",

                  "&:hover": {
                    background: "linear-gradient(135deg,#1D4ED8,#1E40AF)",
                  },
                }}
              >
                View Details
              </Button>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
  );
}

export default ObligationsPage;
